import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import NavigationContext from 'InPlayOverview/services/navigation_context';
import { getEvent, makeGetMarkets } from 'InPlayOverview/selectors';
import { withCompetitionContext } from 'InPlayOverview/helpers/competition';
import marketPicker from 'InPlayOverview/services/market_picker';
import { getEventHref } from 'InPlayOverview/helpers/navigation';
import { Overview } from 'sportsbook-common';

import OutrightOutcomes from './outright_outcomes';
import SeeMoreMarkets from './see_more_markets';

export const OutrightEventComponent = ({
  markets,
  period,
  event,
  sport,
  competition,
  marketType,
  template,
}) => {
  const market = marketPicker(markets, period);

  const eventHref = getEventHref({
    sportId: event.sport_id,
    sport,
    competition,
    eventId: event.id,
  });

  const EventDetail = Overview.EventDetail.Factory(template, event.sport_id);

  return (
    <NavigationContext.Provider value={eventHref}>
      <div className="inply-coupon-row">
        <EventDetail
          eventId={event.id}
          externalMarketProvided
          externalMarket={market}
        />
        <div className="inply-coupon-odds-column">
          {market && (
            (marketType.headers || []).map(
              (h) => <span key={h} className="inply-coupon-odds-label">{h}</span>,
            )
          )}
          {!market && <SeeMoreMarkets />}
        </div>
      </div>
      {market && <OutrightOutcomes market={market} />}
    </NavigationContext.Provider>
  );
};

OutrightEventComponent.propTypes = {
  event: PropTypes.isRequired,
  markets: PropTypes.isRequired,
  marketType: PropTypes.isRequired,
  period: PropTypes.isRequired,
  sport: PropTypes.isRequired,
  competition: PropTypes.isRequired,
  template: PropTypes.string.isRequired,
};

const makeMapStateToProps = () => {
  const getMarkets = makeGetMarkets();

  const mapStateToProps = (state, ownProps) => ({
    event: getEvent(state, ownProps.eventId),
    markets: getMarkets(state, ownProps.eventId),
  });

  return mapStateToProps;
};

export default connect(makeMapStateToProps)(withCompetitionContext(OutrightEventComponent));
